module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_deadhaussonata.44dc2b4d.png";